import Flex from '~/common/components/Flex';
import Formulas from '~/common/components/Formulas';
import Text from '~/common/components/Texts/Text';
import { formatCurrency } from '~/common/util/format';
import type { CalculationResult } from '~/pages/IncomeCalculator/types';
import { pixelsToRem } from '~/theme/typography';

import BreakdownContainer from '../BreakdownContainer';
import BaseFormulas from './BaseFormulas';

type CapitalGainsCalculationBreakdownProps = {
  selectedResult: CalculationResult;
  hideAccordion?: boolean;
  onNewWindow?: (...args: any[]) => any;
};

const CapitalGainsCalculationBreakdown = ({
  selectedResult,
  hideAccordion = false,
  onNewWindow,
}: Readonly<CapitalGainsCalculationBreakdownProps>) => {
  return (
    <BreakdownContainer
      header={`Review ${selectedResult.incomeCalculatorType}`}
      calculatedAmount={selectedResult.calculationAmount}
      hideAccordion={hideAccordion}
      onNewWindow={onNewWindow}
    >
      <BaseFormulas formulas={selectedResult.formulas} />
      <Formulas formulas={selectedResult.formulas} />
      <Flex alignItems="center">
        <Text mr={1} fontSize={pixelsToRem(14)} fontWeight="bold" d="inline">
          Capital Gain:
        </Text>
        <Text
          fontSize={pixelsToRem(14)}
          d="inline"
          data-testid="monthly-income"
        >
          {formatCurrency(selectedResult.calculationAmount)}
        </Text>
      </Flex>
    </BreakdownContainer>
  );
};

export default CapitalGainsCalculationBreakdown;
